import { type FC } from "react";
import { ActionButton, ActionButtonIntent, ActionButtonSize } from "widgets";

import { type Tool } from "@/graphql.ts";

import { type IAgGridCellProps } from "../cell-base-interfaces.js";
import { TableCell } from "./core/TableCell.js";

interface ToolAdminCellProps extends IAgGridCellProps {
  handleToolClicked: (tool: Tool) => void;
}

const ToolAdminCell: FC<ToolAdminCellProps> = (props) => {
  if (!props.value) {
    return null;
  }

  const tool: Tool = props.data.tool;
  const { context } = props;
  const adminContext = context?.adminContext;
  const toolIsExecutable = tool.requireInternetConnection ? adminContext?.hasInternetConnection : true;
  const tooltip = !toolIsExecutable ? props.value + " (Missing Server Internet Connection)" : undefined;

  return (
    <TableCell>
      <ActionButton
        onPress={() => props.handleToolClicked(tool)}
        label={props.value}
        intent={ActionButtonIntent.Primary}
        size={ActionButtonSize.Small}
        isDisabled={!!tooltip}
        tooltip={tooltip ?? `Launch ${tool.name}`}
      />
    </TableCell>
  );
};

export { ToolAdminCell };
export default ToolAdminCell;
